<template>
  <VCDatePicker :model-value="safeValue" @update:model-value="onUpdate">
    <template v-for="(_, name) in $slots" v-slot:[name]="slotProps" :key="name">
      <slot :name="name" v-bind="slotProps" />
    </template>
  </VCDatePicker>
</template>

<script>
import { DatePicker as VCDatePicker } from 'v-calendar';

export default {
  name: 'SafeDatePicker',
  components: { VCDatePicker },
  props: {
    modelValue: {
      type: [String, Date, Object, Array],
      default: null,
    },
  },
  emits: ['update:modelValue'],
  computed: {
    safeValue() {
      return this.modelValue === '' ? null : this.modelValue;
    },
  },
  methods: {
    onUpdate(value) {
      this.$emit('update:modelValue', value === '' ? null : value);
    },
  },
};
</script>
